import { createTheme } from '@mui/material'

export const theme = createTheme({
  palette: {
    primary: {
      dark: '#003673',
      main: '#014EA5',
      light: '#82A0C2',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FA7861',
      light: '#FFDABB',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#051E33',
      secondary: '#4E4E4E',
      disabled: '#888888',
    },
    common: {
      black: '#051E33',
      white: '#FFFFFF',
    },
    success: {
      dark: '#0B6D5E',
      main: '#22A792',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#f1c40f',
    },
    error: {
      main: 'rgb(211, 47, 47)',
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          maxWidth: 'unset',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1em',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        size: 'small',
      },
      styleOverrides: {
        root: {
          fontSize: '1rem',
          textTransform: 'none',
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          fontSize: '0.75em',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiDrawer: {
      defaultProps: {
        sx: {
          width: '33.3vw'
        }
      }
    }
  },
})
